import { render, staticRenderFns } from "./lista_FormatoConvenio.vue?vue&type=template&id=2a53012f&scoped=true"
import script from "./lista_FormatoConvenio.vue?vue&type=script&lang=js"
export * from "./lista_FormatoConvenio.vue?vue&type=script&lang=js"
import style0 from "./lista_FormatoConvenio.vue?vue&type=style&index=0&id=2a53012f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a53012f",
  null
  
)

export default component.exports